import {useAxiosClient} from "~/use/axios/client";
import {SessionApi} from "~/gen/openapi/sblService";
import type {User} from "~/models/auth";
import {MS_MINUTE} from "~/constants/time";
import {keepPreviousData, useQuery, UseQueryOptions} from "@tanstack/vue-query";
import {queryClient} from "~/plugins/vue-query";

export const useUserService = () => {
    const { axiosClient } = useAxiosClient()
    const sessionApi = new SessionApi(undefined, '', axiosClient.value)

    const userQueryOptions: UseQueryOptions<User> = {
        queryKey: ['user'],
        queryFn: async () => {
            try {
                const user = (await sessionApi.sessionGetUserInfo())?.data as unknown as User
                if (user) {
                    (window as any).localStorage.setItem('user', JSON.stringify(user))
                    return user
                }
                return Promise.reject('No user found')
            } catch (e: any) {
                if (e.response && e.response.data && e.response.data.Message) {
                    return Promise.reject(e.response.data.Message)
                }
                return Promise.reject(e)
            }
        },
        staleTime: 5 * MS_MINUTE,
        gcTime: Infinity,
        placeholderData: keepPreviousData,
        networkMode: 'offlineFirst',
        refetchOnWindowFocus: false,
    }

    const userQuery = () => useQuery(userQueryOptions)

    // For use in .ts-files and stores. Use the userQuery instead in vue-components.
    const getCurrentUser = async () => {
        return queryClient.ensureQueryData(userQueryOptions)
    }

    return {
        userQueryOptions,
        userQuery,
        getCurrentUser,
    }
}